import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/tunnel`;
const TAILLES = ['Petite exploitation', 'Exploitation moyenne', 'Grande structure / multi-sites', 'Collectif (CUMA, ETA, syndicat)'];

export const DemandeForm = ({ metier }) => {
  const [f, setF] = useState({ type_demande: 'demo', nom: '', exploitation: '', email: '', telephone: '', taille: '', pays: 'France', message: '', site_web: '' });
  const [envoi, setEnvoi] = useState(false);
  const [fait, setFait] = useState('');
  const maj = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const envoyer = async (e) => {
    e.preventDefault();
    setEnvoi(true);
    try {
      const { data } = await axios.post(`${API}/demande`, { ...f, metier: metier.slug });
      setFait(data.message);
    } catch (err) {
      toast.error("Votre demande n'est pas partie : vérifiez votre adresse mail.");
    } finally {
      setEnvoi(false);
    }
  };

  if (fait) return <p data-testid="tunnel-demande-confirmation" className="rounded-2xl bg-white p-8 text-lg text-[#12321f]">{fait}</p>;
  return (
    <form onSubmit={envoyer} data-testid="tunnel-demande-form" className="rounded-2xl bg-white p-6 md:p-8 shadow-xl space-y-4">
      <div className="flex gap-2">
        {[['demo', 'Une démo sur place'], ['visio', 'Une visio de 30 min']].map(([v, l]) => (
          <button key={v} type="button" onClick={() => setF({ ...f, type_demande: v })} data-testid={`tunnel-choix-${v}`}
            className={`flex-1 rounded-full px-4 py-2 text-sm font-bold transition-colors ${f.type_demande === v ? 'bg-[#12321f] text-white' : 'bg-[#ece5d3] text-[#12321f]'}`}>{l}</button>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <Input required placeholder="Votre nom" value={f.nom} onChange={maj('nom')} data-testid="tunnel-input-nom" />
        <Input placeholder="Nom de l'exploitation" value={f.exploitation} onChange={maj('exploitation')} data-testid="tunnel-input-exploitation" />
        <Input required type="email" placeholder="Email" value={f.email} onChange={maj('email')} data-testid="tunnel-input-email" />
        <Input placeholder="Téléphone" value={f.telephone} onChange={maj('telephone')} data-testid="tunnel-input-telephone" />
        <select value={f.taille} onChange={maj('taille')} data-testid="tunnel-select-taille" className="h-10 rounded-md border px-3 text-sm bg-white">
          <option value="">Taille de l'exploitation</option>
          {TAILLES.map((t) => <option key={t}>{t}</option>)}
        </select>
        <Input placeholder="Pays" value={f.pays} onChange={maj('pays')} data-testid="tunnel-input-pays" />
      </div>
      <input type="text" tabIndex={-1} autoComplete="off" value={f.site_web} onChange={maj('site_web')} className="hidden" aria-hidden="true" />
      <Textarea placeholder="Ce que vous aimeriez simplifier (facultatif)" value={f.message} onChange={maj('message')} data-testid="tunnel-input-message" />
      <button type="submit" disabled={envoi} data-testid="tunnel-demande-submit"
        className="w-full rounded-full bg-[#c9a227] py-3 font-bold text-[#12321f] transition-transform hover:-translate-y-0.5 disabled:opacity-60">
        {envoi ? 'Envoi…' : f.type_demande === 'demo' ? 'Je veux ma démo' : 'Je réserve ma visio'}
      </button>
    </form>
  );
};
